export default "__VITE_ASSET__CTu2Zr3O__"